class TestimonialsCarousel {
  constructor(section) {
    this.section = section;
    this.track = section.querySelector('[data-testimonials-track]');
    this.cards = Array.from(this.track.children);
    this.prevBtn = section.querySelector('[data-testimonials-prev]');
    this.nextBtn = section.querySelector('[data-testimonials-next]');
    this.index = 0;

    this.update = this.update.bind(this);
    this.prevBtn.addEventListener('click', () => this.go(-1));
    this.nextBtn.addEventListener('click', () => this.go(1));
    window.addEventListener('resize', this.update);
    this.update();
  }

  visibleCount() {
    const width = this.section.clientWidth;
    if (width < 749) return 1;
    if (width < 990) return 2;
    return 3;
  }

  maxIndex() {
    return Math.max(0, this.cards.length - this.visibleCount());
  }

  go(direction) {
    this.index = Math.min(Math.max(this.index + direction, 0), this.maxIndex());
    this.update();
  }

  update() {
    const max = this.maxIndex();
    this.index = Math.min(this.index, max);

    const card = this.cards[0];
    if (!card) return;
    const cardWidth = card.getBoundingClientRect().width;
    const gap = parseFloat(getComputedStyle(this.track).gap || 0);
    const offset = this.index * (cardWidth + gap);
    this.track.style.transform = `translateX(-${offset}px)`;

    this.prevBtn.disabled = this.index === 0;
    this.nextBtn.disabled = this.index >= max;
  }
}

document.querySelectorAll('.testimonials-section').forEach((section) => {
  new TestimonialsCarousel(section);
});